import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export function GoogleButton() {
  const { t } = useLang();
  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button type="button" variant="outline" className="w-full" onClick={onGoogle} data-testid="google-login-button">
      <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.3h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.9c2.3-2.1 3.7-5.1 3.7-8.8z"/><path fill="#34A853" d="M12 24c3.2 0 6-1.1 8-2.9l-3.7-2.9c-1 .7-2.4 1.2-4.3 1.2-3.3 0-6-2.2-7-5.3l-3.9 3C3.9 21.3 7.6 24 12 24z"/><path fill="#FBBC05" d="M5 14.1c-.2-.7-.4-1.4-.4-2.1s.1-1.4.4-2.1l-3.9-3C.4 8.2 0 10 0 12s.4 3.8 1.1 5.1l3.9-3z"/><path fill="#EA4335" d="M12 4.7c1.8 0 3 .8 3.7 1.4l3.3-3.2C17.9 1.1 15.2 0 12 0 7.6 0 3.9 2.7 2 6.9l3.9 3c1-3.1 3.8-5.2 7.1-5.2z"/></svg>
      {t("auth.google")}
    </Button>
  );
}

export default function Login() {
  const { t } = useLang();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/api/auth/login", { email, password });
      setUser(data);
      navigate(location.state?.from || "/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-4 py-16" data-testid="login-page">
      <h1 className="font-display text-3xl font-semibold sm:text-4xl" data-testid="login-title">{t("auth.login.title")}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t("auth.login.sub")}</p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email">{t("auth.email")}</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
        </div>
        <div>
          <Label htmlFor="password">{t("auth.password")}</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        </div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit-button">{t("auth.login.btn")}</Button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-muted-foreground">
        <span className="h-px flex-1 bg-border" />or<span className="h-px flex-1 bg-border" />
      </div>
      <GoogleButton />
      <div className="mt-6 flex justify-between text-sm">
        <Link to="/signup" className="font-medium text-primary hover:underline" data-testid="login-to-signup">{t("auth.no.account")}</Link>
        <Link to="/forgot-password" className="text-muted-foreground hover:underline" data-testid="login-forgot-link">{t("auth.forgot")}</Link>
      </div>
    </div>
  );
}
